import styled, { css, keyframes } from 'styled-components';

export const SIDE_DRAWER_WIDTH = '45%';

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3000000002;
  background: ${(props) => props.theme.$black}66;
  animation: ${fadeIn} 0.3s ease forwards;
`;

const variants = {
  main: css<{ $shifted: boolean }>`
    right: ${(props) => (props.$shifted ? SIDE_DRAWER_WIDTH : '0')};
    left: ${(props) => (props.$shifted ? '0' : 'auto')};
    width: ${(props) => (props.$shifted ? 'auto' : '60%')};
    min-width: 480px;
    z-index: 3000000003;
    box-shadow: -8px 0 24px ${(props) => props.theme.$black}33;
    transition: right 0.3s ease;
  `,
  side: css`
    right: 0;
    width: ${SIDE_DRAWER_WIDTH};
    min-width: 420px;
    z-index: 3000000004;
    border-left: 1px solid ${(props) => props.theme.$gray300};
  `,
};

export const Panel = styled.aside<{
  $variant: 'main' | 'side';
  $shifted: boolean;
  $width?: string;
}>`
  position: fixed;
  top: 0;
  bottom: 0;
  max-width: 100%;
  animation: ${slideIn} 0.3s ease forwards;
  will-change: transform;
  ${(props) => variants[props.$variant]}
  ${(props) =>
    props.$width &&
    css`
      width: ${props.$width};
      max-width: calc(100vw - 88px);
    `}

  .drawer-header {
    box-shadow: 0 2px 4px ${(props) => props.theme.$black}14;
  }

  .drawer-title {
    font-size: 20px;
    color: ${(props) => props.theme.$dark};
  }

  .drawer-scroll {
    flex: 1;
    min-height: 0;
  }
`;
